<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('notificationConfigs.title') }}</h2>
      <p class="text-center">
        {{ $t('notificationConfigs.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <edit-notification-config-dialog :show="showEdit" :form-details="resourceToEdit" @close="showEdit=false" :notification-types="notificationTypes" />
          <h4 slot="header" class="card-title">{{ $t('notificationConfigs.tableTitle') }}</h4>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="row">
                <div class="col-6">
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      :placeholder="$t('generic.searchInTablePlaceholder')"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
                <div class="col-6" v-if="$auth.can({notification_configuration: 'create'}, 'permissions')">
                  <create-notification-config-btn/>
                </div>
              </div>
            </div>

            <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="$t(column.label)"
              >
              </el-table-column>
              <!-- Updated & Created -->
              <el-table-column :label="$t('notificationConfigs.details.eventTypes')" min-width="180">
                <div slot-scope="{ row }">
                  <!-- {{ row.events }} -->
                  <badge v-for="(value, idx) in row.events" :key="idx" type="info">{{ value }}</badge>
                </div>
              </el-table-column>
              <el-table-column :label="$t('notificationConfigs.details.pluginConfig')" min-width="300">
                <div slot-scope="{ row }">
                  <!-- {{ row.configuration }} -->
                  <ul>
                    <li>
                      <span class="text-primary">{{$t('notificationConfigs.details.webhook_url')}}:</span> {{ row.configuration.webhook_url }}
                    </li>
                    <li>
                      <span class="text-primary">{{$t('notificationConfigs.details.environment')}}:</span> {{ row.configuration.environment }}
                    </li>
                    <li v-if="row.configuration.discord_error_message">
                      <span class="text-primary">{{$t('notificationConfigs.form.discord_error_message')}}:</span> {{ row.configuration.discord_error_message }}
                    </li>
                  </ul>
                </div>
              </el-table-column>
              <el-table-column :label="$t('notificationConfigs.details.pluginStatus')" min-width="180">
                <div slot-scope="{ row }">
                 <span v-if="row.status !== ''">
                   {{ row.status }} {{row.message}}
                 </span>
                </div>
              </el-table-column>
              <el-table-column :label="$t('generic.created')" min-width="180">
                <div slot-scope="{ row }">
                  <!-- TODO: translate time -->
                  {{ row.created_at | time }}
                </div>
              </el-table-column>
              <el-table-column :label="$t('notificationConfigs.details.paused')" min-width="100">
                <div slot-scope="props">
                  <base-switch v-model="props.row.disabled" @click.native="handlePause(props.$index, props.row)" :on-text="$t('notificationConfigs.form.pausedSwitchON')" :off-text="$t('notificationConfigs.form.pausedSwitchOFF')" v-if="$auth.can({notification_configuration: 'update'}, 'permissions')"/>
                  <span v-else>{{props.row.disabled}}</span>
                </div>
              </el-table-column>
              <el-table-column :label="$t('generic.createdBy')" min-width="180">
                <div slot-scope="{ row }">
                  <!-- TODO: translate time -->
                  {{ row.created_by }}
                </div>
              </el-table-column>
              <el-table-column :min-width="135" align="right" v-if="$auth.can({notification_configuration: 'update'}, 'permissions') || $auth.can({notification_configuration: 'delete'}, 'permissions')">
                <div slot-scope="props">
                  <base-button
                    v-if="$auth.can({notification_configuration: 'update'}, 'permissions')"
                    @click.native="handleEdit(props.$index, props.row)"
                    class="mr-2"
                    type="info"
                    size="sm"
                    icon
                    round
                    simple>
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>

                  <!-- delete -->
                  <base-button
                    v-if="$auth.can({notification_configuration: 'delete'}, 'permissions')"
                    @click.native="handleDelete(props.$index, props.row)"
                    class=""
                    type="danger"
                    size="sm"
                    icon
                    round
                    simple>
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{$t('generic.tablePaginationSummary', {from: from+1, to: to, total: total})}}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div
  >
</template>
<script>
  import {mapActions, mapState} from 'vuex'
  import {Option, Select, Table, TableColumn} from 'element-ui';
  import {Badge, BaseAlert, BasePagination, BaseSwitch} from 'src/components';
  import CreateNotificationConfigBtn from "./CreateNotificationConfigBtn";
  import EditNotificationConfigDialog from "./EditNotificationConfigDialog";
  import Fuse from 'fuse.js';
  import swal from 'sweetalert2';

  export default {
    name: 'notifications',
    components: {
      BasePagination,
      BaseAlert,
      Badge,
      BaseSwitch,
      CreateNotificationConfigBtn,
      EditNotificationConfigDialog,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    computed: {
      ...mapState({
        loading: state => state.notification_config.loading,
        error: state => state.notification_config.error,
        notificationTypes: state => state.notification_config.notificationTypes,
      }),
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      }
    },
    data() {
      return {
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['id', 'name'],
        tableColumns: [
          {
            prop: 'plugin',
            label: 'notificationConfigs.details.plugin',
            minWidth: 100
          }
        ],
        tableData: [],
        searchedData: [],
        fuseSearch: null,
        showEdit: false,
        resourceToEdit: {}
      };
    },
    methods: {
      ...mapActions(['LoadNotificationConfigs', 'DeleteNotificationConfig', 'UpdateNotificationConfig', 'GetNotificationTypes']),
      handleEdit(index, row) {
        this.resourceToEdit = {
          id: row.id,
          disabled: row.disabled,
          plugin: row.plugin,
          events: row.events,
          webhookUrl: row.configuration.webhook_url,
          environment: row.configuration.environment,
        };

        if (row.plugin === 'discord') {
          this.resourceToEdit.discord_error_message = row.configuration.discord_error_message
        }
        this.showEdit = true;
      },
      handlePause(index, row) {
        this.UpdateNotificationConfig(row).then(() => {
          this.LoadNotificationConfigs()
        })
      },
      handleDelete(index, row) {
        swal({
          title: this.$t('notificationConfigs.delete.text'),
          text: `'${row.plugin}/${row.configuration.environment}'`,
          confirmButtonText: this.$t('notificationConfigs.delete.actionBtnLabel'),
          cancelButtonText: this.$t('notificationConfigs.delete.cancelBtnLabel'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-secondary',
          type: 'question',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            this.DeleteNotificationConfig(row).then(() => {
              if (this.error == null) {
                this.$notify({
                  type: 'success',
                  message: this.$t('notificationConfigs.delete.deletedNotification', {
                    plugin: row.plugin,
                    environment: row.configuration.environment
                  }),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
              }
            })
          }
        });
      },
    },
    mounted() {
      this.LoadNotificationConfigs();
      this.GetNotificationTypes()
    },
    watch: {
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = this.tableData;
        if (value !== '') {
          result = this.fuseSearch.search(this.searchQuery);
        }
        this.searchedData = result;
      },
      "$store.state.notification_config.data"(configs) {
        this.tableData = configs
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      }
    }
  };
</script>
<style scoped>
</style>
